import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/helpers/common.service';

@Component({
  selector: 'app-s-rodo-description',
  templateUrl: './s-rodo-description.component.html',
  styleUrls: ['./s-rodo-description.component.scss'],
})
export class SRodoDescriptionComponent implements OnInit {
  providerInfo: any;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    try {
      this.commonService.onLoaderChange.next(true);
      this.providerInfo = await this.commonService.getHtmlTemplate({ route: 'service_rodo' });
      this.commonService.onLoaderChange.next(false);
    } catch (error) {
      console.error(error);
      this.commonService.onLoaderChange.next(false);
    }
  }
}
